export default "__VITE_ASSET__CZyid3y0__"